export const NEW_REGISTARTION_DATA_SUCCESS = "NEW_REGISTARTION_DATA_SUCCESS";
export const NEW_REGISTARTION_DATA_ERROR = "NEW_REGISTARTION_DATA_ERROR";
export const NEW_REGISTARTION_DATA_START = "NEW_REGISTARTION_DATA_START";

export const FIRST_TIME_APPROVAL_SUCCESS = "FIRST_TIME_APPROVAL_SUCCESS";
export const FIRST_TIME_APPROVAL_ERROR = "FIRST_TIME_APPROVAL_ERROR";
export const FIRST_TIME_APPROVAL_START = "FIRST_TIME_APPROVAL_START";